import axios from 'axios';
import { TenantCreationPayload } from './shared';
import { Tenant } from '@wix/answers-api';
import { signupUrl } from './utils';
import * as momentTimezone from 'moment-timezone';
import { MarketingParams, MarketoLeadData } from './marketo/mkto-api-client';

export const CAPTCHA_SITE_KEY = '6LcVIUMUAAAAAGdb_540b5gDIH-vOB4wIbmC4vDJ';

export let dearCompilerLetMeBuild: Tenant;

const getBaseUrlOnClient = () => {
	try {
		return window && (window as any).__isProduction ? '//help.wixanswers.com' : '//wix.devwixanswers.com';
	} catch (e) {
		return '//wix.devwixanswers.com';
	}
};

const baseUrl = getBaseUrlOnClient();
const apiUrl = `${baseUrl}/api/v1`;
const signupWithWixRedirect = `${apiUrl}/accounts/signup/wix`;

export type NewTenantParams = {
	userEmail: string;
	userName: string;
	userPassword: string;
	organizationName: string;
	subdomain: string;
	locale: string;
};

export type NewWixTenantParams = {
	userName: string;
	organizationName: string;
	subdomain: string;
	locale: string;
	token: string;
	email: string;
};

export type CaptchaParams = {
	recaptchaValue: string;
};

const request = (url: string, method: 'POST' | 'GET' | 'DELETE' | 'PUT', body?: any, raw = false): Promise<any> => {
	return axios.request({
		method,
		headers: {
			// tslint:disable-next-line:object-literal-key-quotes
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		url,
		data: raw ? body : (body ? JSON.stringify(body) : null)
	})
	.then((req) => req.data)
	.catch((err) => Promise.reject(err.response));
};

export const post = (url: string, body: any) => {
	return request(url, 'POST', body);
};

export const put = (url: string, body: any) => {
	return request(url, 'PUT', body);
};

export const get = (url: string) => {
	return request(url, 'GET');
};

export const doSignupWithEmail = (params: NewTenantParams & CaptchaParams, marketingParams: MarketingParams): Promise<TenantCreationPayload> => {
	const timezone = momentTimezone.tz.guess(true);
	return post('/api/signup', {...params, 'g-recaptcha-response': params.recaptchaValue, timezone, marketingParams});
};

export const doWixSsoRedirect = () => {
	location.replace(signupWithWixRedirect);
};

export const doSignupRedirect = () => {
	setTimeout(() => {
		location.replace(signupUrl);
	}, 300);
};

export const doSignupWithWix = (params: NewWixTenantParams & CaptchaParams): Promise<TenantCreationPayload> => {
	const timezone = momentTimezone.tz.guess(true);
	return post('/api/signup/wix', {...params, 'g-recaptcha-response': params.recaptchaValue, timezone});
};

export const isNameAvailable = (name: string): Promise<boolean> => {
	return post('/api/isNameAvailable', {name});
};

export const reportToMarketo = (newLead: MarketoLeadData): Promise<any> => {
	return post('/api/updateMkto', newLead);
};
